export function isDouble(value) {
    return typeof value === 'number' && isFinite(value);
}

export function isStrictDoubleOrNumericString(value) {
    // 1. Odrzucenie null i stringa "null"
    if (value === null || (typeof value === 'string' && value.toLowerCase() === 'null')) {
        return false; // Zwraca false dla null, "null", "NulL" itp.
    }

    // 2. Walidacja liczb i stringów numerycznych

    // Obsługa typu 'number' (double)
    if (typeof value === 'number') {
        // Sprawdzamy, czy jest to skończona liczba (odrzuca NaN i Infinity)
        return isFinite(value);
    }

    // Obsługa typu 'string'
    if (typeof value === 'string') {
        // Używamy Number(), który jest rygorystyczny i zwraca NaN dla nie-numerycznych stringów jak "100a".
        const num = Number(value);

        // Sprawdzamy, czy konwersja dała skończoną liczbę.
        return isFinite(num);
    }

    // 3. Odrzucenie innych typów (undefined, boolean, object, itp.)
    return false;
}